import { render, staticRenderFns } from "./UpdateBusinessMemberFullName.vue?vue&type=template&id=11d50062&"
import script from "./UpdateBusinessMemberFullName.vue?vue&type=script&lang=js&"
export * from "./UpdateBusinessMemberFullName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports